import castPetKiwi from "../../../assets/castPetKiwi.png";
import castPetDoggerino from "../../../assets/castPetDoggerino.png";

export const petImages = [castPetDoggerino, castPetKiwi];

export function randomBuriDog() {
  return petImages[Math.floor(Math.random() * petImages.length)];
}
